var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_complete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-+-circle-(active)",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    cx: 10.9710526,
    cy: 10.9710526,
    r: 10.295614
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9710526,21.9421053 C4.91190757,21.9421053 -1.34688235e-14,17.0301977 -1.42108547e-14,10.9710526 C-1.4952886e-14,4.91190757 4.91190757,-1.30978078e-14 10.9710526,-1.42108547e-14 C17.0301977,-1.53239016e-14 21.9421053,4.91190757 21.9421053,10.9710526 C21.9346621,17.027112 17.027112,21.9346621 10.9710526,21.9421053 Z M10.9710526,1.35087719 C5.65797645,1.35087719 1.35087719,5.65797645 1.35087719,10.9710526 C1.35087719,16.2841288 5.65797645,20.5912281 10.9710526,20.5912281 C16.2841288,20.5912281 20.5912281,16.2841288 20.5912281,10.9710526 C20.5848479,5.66062145 16.2814838,1.35725737 10.9710526,1.35087719 Z",
    id: "Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11070175,15.0526316 C8.9318754,15.0543955 8.75968948,14.9849657 8.63210526,14.8596491 L5.53666667,11.7584211 C5.2702135,11.4919679 5.27021351,11.0599619 5.53666667,10.7935088 C5.80311984,10.5270556 6.23512578,10.5270556 6.50157895,10.7935088 L9.11070175,13.4238596 L15.4482456,7.08631579 C15.6206106,6.91395081 15.871838,6.84663463 16.107293,6.90972459 C16.3427479,6.97281455 16.5266591,7.15672579 16.5897491,7.39218073 C16.6528391,7.62763566 16.5855229,7.87886309 16.4131579,8.05122807 L9.58929825,14.8596491 C9.46171403,14.9849657 9.28952811,15.0543955 9.11070175,15.0526316 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplete);
export default __webpack_public_path__ + "static/media/icon_complete.8941df1beb101e70a8a687873e71440f.svg";
export { ForwardRef as ReactComponent };